import React, { useState, useEffect } from 'react';
import './OverrideModal.css';
import { OverrideData } from './types';

interface SetOverrideModalProps {
  mode: 'set';
  existing?: OverrideData;
  onConfirm: (data: OverrideData) => void;
  onClose: () => void;
}

interface CancelOverrideModalProps {
  mode: 'cancel';
  onConfirm: () => void;
  onClose: () => void;
}

type OverrideModalProps = SetOverrideModalProps | CancelOverrideModalProps;

export default function OverrideModal(props: OverrideModalProps) {
  const [hours, setHours] = useState('');
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (props.mode === 'set' && props.existing) {
      setHours(String(props.existing.hours));
      setReason(props.existing.reason);
    }
  }, []);

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) props.onClose();
  };

  if (props.mode === 'cancel') {
    return (
      <div className="tc-modal-overlay" onClick={handleOverlayClick}>
        <div className="tc-modal">
          <h3 className="tc-modal-title">Remove Override</h3>
          <p className="tc-modal-body-text">Remove this manual hour override and revert to the original hours?</p>
          <div className="tc-modal-actions">
            <button className="tc-btn-secondary" onClick={props.onClose}>Cancel</button>
            <button className="tc-btn-danger" onClick={props.onConfirm}>Remove Override</button>
          </div>
        </div>
      </div>
    );
  }

  const hoursNum = parseFloat(hours);
  const isValid = !isNaN(hoursNum) && hoursNum >= 0 && reason.trim().length > 0;

  const handleConfirm = () => {
    if (!isValid) return;
    props.onConfirm({ hours: hoursNum, reason: reason.trim() });
  };

  return (
    <div className="tc-modal-overlay" onClick={handleOverlayClick}>
      <div className="tc-modal">
        <h3 className="tc-modal-title">Override Hours</h3>

        <div className="tc-modal-field">
          <label className="tc-modal-label">
            Hours <span className="tc-modal-required">*</span>
          </label>
          <input
            className="tc-modal-input"
            type="number"
            min="0"
            step="0.25"
            placeholder="e.g. 5.5"
            value={hours}
            onChange={e => setHours(e.target.value)}
            autoFocus
          />
        </div>

        <div className="tc-modal-field">
          <label className="tc-modal-label">
            Reason <span className="tc-modal-required">*</span>
          </label>
          <textarea
            className="tc-modal-textarea"
            rows={3}
            placeholder="Reason for the override..."
            value={reason}
            onChange={e => setReason(e.target.value)}
          />
        </div>

        <div className="tc-modal-actions">
          <button className="tc-btn-danger" onClick={props.onClose}>Cancel</button>
          <button
            className="tc-btn-primary"
            onClick={handleConfirm}
            disabled={!isValid}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
